import React, {useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';
import closeButton from '../../static_files/closeButtonHover.svg';
import GoBackArrow from '../../static_files/goBackArrow.svg';
import SuccessCheckmark from '../../static_files/check-circle-white.svg';
import reserveSuccess from '../../static_files/reserveSuccess.svg';
import usdtIcon from '../../static_files/usdt.svg';
import usdcIcon from '../../static_files/usdc.svg';

import goldBg from '../../static_files/buttonBackgroundGold.svg';
import {SwapMainAppContext} from "../../context/SwapMainAppContext";
import {useLocation, useNavigate} from "react-router-dom";
import {PRISMAX_BACKEND_URL} from "../../configs/config";
import {useIsMobile} from "../../utils/utils";

function UpgradeMembershipModal({
                                    onClose,
                                    onGoBack,
                                    paymentSuccess = false
                                }) {

    const [selectedPayment, setSelectedPayment] = useState('USD');
    const [showSuccess, setShowSuccess] = useState(false);
    const [transactionHash, setTransactionHash] = useState(null);
    const [price, setPrice] = useState(99)
    const {
        showNotification,
        userClass,
        setUserClass,
        setTransactionTrigger,
        setAmount,
        setSelectedToken,
        setOnMembershipPaymentSuccess,
        walletAddress,
        isProcessing,
        setIsProcessing,
        fetchUserInfoAfterConnect,
        usdcBalance,
        usdtBalance
    } = useContext(SwapMainAppContext);
    const location = useLocation();
    const navigate = useNavigate();
    const isMobile = useIsMobile(768)
    const handleClose = () => {
        setIsProcessing(false);
        onClose();
    };

    const handleGoBack = () => {
        setIsProcessing(false);
        if (onGoBack) {
            onGoBack();
        } else {
            handleClose();
        }
    };

    const handleRedirect = () => {
        setIsProcessing(false);
        onClose(); // if you still want to close the modal
        navigate('/fleet'); // navigate to /fleet
    };

    useEffect(() => {
        if (paymentSuccess) {
            setShowSuccess(true)
        }
    }, [showSuccess]);


    useEffect(() => {
        const storedUserClass = localStorage.getItem('userClass');
        if (storedUserClass && setUserClass) {  // Add null check
            setUserClass(storedUserClass);
            if (storedUserClass === 'Amplifier Member') {
                setPrice(999)
            }
        }
    }, [setUserClass]);

    const handlePaymentClick = async () => {
        setIsProcessing(true);

        if (selectedPayment === 'USD') {
            try {
                let userId;
                userId = localStorage.getItem('userId')
                if (!userId || !userClass) {

                    await fetchUserInfoAfterConnect()
                    setUserClass(localStorage.getItem('userClass'))
                    userId = localStorage.getItem('userId')
                    if (!userId || !userClass) {
                        showNotification('error', 'Network Error. Please try to login again.');
                        setIsProcessing(false);
                        return;
                    }

                }

                const targetMembership = userClass === 'Explorer Member'
                    ? 'Amplifier Membership'
                    : 'Innovator Membership';

                // todo add Authorization
                const response = await fetch(`${PRISMAX_BACKEND_URL}/api/create-stripe-checkout-session`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        user_id: userId,
                        membership_type: targetMembership
                    })
                });

                const data = await response.json();

                if (data.success && data.checkout_url) {
                    localStorage.setItem('pendingUpgrade', JSON.stringify({
                        from: userClass,
                        to: targetMembership,
                        timestamp: Date.now()
                    }));

                    window.location.href = data.checkout_url;
                } else {
                    console.error('Failed to create checkout session:', data.error);
                    setIsProcessing(false);
                    showNotification('error', 'Failed to create payment session. Please try again.');

                }
            } catch (error) {
                console.error('Error:', error);
                setIsProcessing(false);
                showNotification('error', 'Network error. Please try again.');

            }
        } else {
            if (!walletAddress) {
                showNotification('error', 'Please connect your wallet to continue.')
                setIsProcessing(false)
                return
            }
            try {
                setSelectedToken(selectedPayment);
                if (userClass === 'Explorer Member') {
                    setAmount(99);
                } else if (userClass === 'Amplifier Member') {
                    setAmount(999);
                }
                setTransactionTrigger((prev) => prev + 1);
            } catch (error) {
                console.error('Payment failed:', error);
                setIsProcessing(false);
            }
        }
    };

    useEffect(() => {
        setOnMembershipPaymentSuccess(() => (txHash) => {
            if (txHash) {
                setTransactionHash(txHash);
            }
            const current = localStorage.getItem('userClass')
            if (current === 'Explorer Member') {
                localStorage.setItem('userClass', 'Amplifier Member');
                setUserClass('Amplifier Member')
            } else if (current === 'Amplifier Member') {
                localStorage.setItem('userClass', 'Innovator Member');
                setUserClass('Innovator Member')

            }
            setShowSuccess(true);
            setIsProcessing(false);
        });

        return () => {
            setOnMembershipPaymentSuccess(() => () => {
                console.log("onMembershipPaymentSuccess default no-op called");
            });
        };
    }, [setOnMembershipPaymentSuccess, setTransactionHash, setShowSuccess, setIsProcessing]);

    const handleContinueReserving = () => {
        setIsProcessing(false);
        onClose();
    };

    const handleSuccessGoBack = () => {
        setIsProcessing(false);
        setShowSuccess(false);
    };

    // Success view
    if (showSuccess) {
        return ReactDOM.createPortal(
            <div className={styles.modalOverlay}
                 onClick={(e) => {
                     if (e.target === e.currentTarget) {
                         handleClose();
                     }
                 }}>
                <div className={`${styles.modalContainer} ${styles.upgradeModalContainer}`}>
                    <div className={styles.reserveModalHeader}>
                        {!paymentSuccess && (<button onClick={handleSuccessGoBack} className={styles.goBackButton}>
                            <img src={GoBackArrow} alt='<'/> Go Back
                        </button>)}

                        <img src={closeButton} className={styles.closeBtn} onClick={handleClose} alt='Close modal'/>
                    </div>

                    <div className={styles.successContent}>
                        <img src={reserveSuccess}
                             style={{height: "40px", width: "40px", marginTop: '50px', marginBottom: '32px'}}
                             alt='success'/>

                        <h2 className={styles.upgradeSuccessTitle}>Congratulations!</h2>

                        {(paymentSuccess && userClass === 'Explorer Member') || (!paymentSuccess && userClass === 'Amplifier Member') && (
                            <p style={{marginBottom: '32px'}}>
                                You are now an Amplifier Member.
                            </p>)}
                        {(paymentSuccess && userClass === 'Amplifier Member') || (!paymentSuccess && userClass === 'Innovator Member') && (
                            <p style={{marginBottom: '32px'}}>
                                You are now an Innovator Member.
                            </p>)}


                        {transactionHash && (
                            <p className={styles.transactionInfo}>
                                Transaction: {transactionHash.substring(0, 8)}...{transactionHash.substring(-8)}
                            </p>
                        )}
                        {location.pathname !== '/account' ? <button
                                className={styles.upgradeButton}
                                onClick={handleContinueReserving}
                                disabled={isProcessing}
                                style={{backgroundImage: `url(${goldBg})`, maxWidth: "271px"}}
                            >
                                Continue reserving your robot →
                            </button> :
                            <button
                                className={styles.upgradeButton}
                                onClick={handleRedirect}
                                disabled={isProcessing}
                                style={{backgroundImage: `url(${goldBg})`, maxWidth: "271px"}}
                            >
                                View your fleet→
                            </button>
                        }

                    </div>
                </div>
            </div>,
            document.getElementById('root')
        );
    }

    // Payment selection view
    return ReactDOM.createPortal(
        <div className={styles.modalOverlay}
             onClick={(e) => {
                 if (e.target === e.currentTarget) {
                     handleClose();
                 }
             }}>
            <div className={`${styles.modalContainer}`}>
                <div className={styles.reserveModalHeader}>
                    <button onClick={handleGoBack} className={styles.goBackButton}>
                        <img src={GoBackArrow} alt='<'/> Go Back
                    </button>
                    <img src={closeButton} className={styles.closeBtn} onClick={handleClose}
                         alt='Close modal'/>
                </div>
                <div style={{display: 'flex', width: '100%', justifyContent: 'center'}}>
                    {userClass === 'Amplifier Member' ?

                        <p className={styles.upgradeModalTitle}>
                            Join our Innovator community to advance robotics intelligence and drive faster adoption
                            together.
                        </p> : <p className={styles.upgradeModalTitle}>
                            Join our Amplifier community to advance robotics intelligence and drive faster adoption
                            together.
                        </p>}</div>
                {isMobile && (<div className={styles.buttonContainer} style={{marginBottom: '24px'}}>
                    <button
                        className={styles.upgradeButton}
                        onClick={handlePaymentClick}
                        disabled={isProcessing}
                        style={{backgroundImage: `url(${goldBg})`}}
                    >
                        {isProcessing
                            ? 'Processing...'
                            : (selectedPayment !== 'USD' && !walletAddress ? 'Connect Wallet' :
                                (userClass === 'Amplifier Member'
                                    ? 'Become an Innovator Now'
                                    : 'Become an Amplifier Now'))}
                    </button>
                </div>)}
                <div className={`${styles.upgradeContent}`}>
                    <div>
                        {userClass === 'Explorer Member' ?
                            <h3 className={styles.membershipTitle}>Amplifier Member</h3>
                            : <h3 className={styles.membershipTitle}>Innovator Member</h3>
                        }
                        <div className={styles.benefitsList}>

                            {userClass === 'Explorer Member' && (<>
                                <div className={styles.benefitItem}>
                                    <img src={SuccessCheckmark} alt='success'/>
                                    <span>Robot fleet access</span>
                                </div>
                                <div className={styles.benefitItem}>
                                    <img src={SuccessCheckmark} alt='success'/>
                                    <span>Enhanced Prisma earning (3x speed)</span>
                                </div>
                            </>)}
                            {userClass === 'Amplifier Member' && (<>
                                <div className={styles.benefitItem}>
                                    <img src={SuccessCheckmark} alt='success'/>
                                    <span>Teleop tech suite access</span>
                                </div>
                                <div className={styles.benefitItem}>
                                    <img src={SuccessCheckmark} alt='success'/>
                                    <span>Full AI model dataset library</span>
                                </div>
                                <div className={styles.benefitItem}>
                                    <img src={SuccessCheckmark} alt='success'/>
                                    <span>Custom robotics AI model</span>
                                </div>
                            </>)}
                        </div>
                    </div>
                    <div className={styles.verticalLine}></div>
                    <div className={styles.horizontalLine}></div>

                    <div className={styles.paymentSection}>
                        <h4 className={styles.membershipTitle} style={{marginBottom: '8px'}}>Payment
                            method</h4>
                        <p className={styles.paymentSubtitle} style={{marginBottom: '24px'}}>Please
                            select payment
                            method. This is a one time payment</p>

                        <div className={styles.paymentOptions}>
                            <button
                                className={`${styles.paymentOption} ${selectedPayment === 'USD' ? styles.selected : ''}`}
                                onClick={() => setSelectedPayment('USD')}
                            >
                                USD
                            </button>
                            <button
                                className={`${styles.paymentOption} ${selectedPayment === 'USDT' ? styles.selected : ''}`}
                                onClick={() => setSelectedPayment('USDT')}
                            >
                                USDT
                            </button>
                            <button
                                className={`${styles.paymentOption} ${selectedPayment === 'USDC' ? styles.selected : ''}`}
                                onClick={() => setSelectedPayment('USDC')}
                            >
                                USDC
                            </button>
                        </div>
                        {selectedPayment !== 'USD' && (
                            <div className={styles.payWithContainer}>
                                <div className={styles.payWithContainerLeft}>
                                    {selectedPayment === 'USDT' ?
                                        <img style={{width: '28px', height: '28px'}} src={usdtIcon} alt='USDT'/> :
                                        <img style={{width: '28px', height: '28px'}} src={usdcIcon} alt='USDC'/>}
                                    <div className={styles.payWithTextContainer}>
                                        <div className={styles.greyText}>Pay with</div>
                                        <div className={styles.text}> {selectedPayment} (Solana)</div>
                                    </div>
                                </div>

                                <div className={styles.payWithTextContainer}>
                                    <div className={styles.greyText}>Available balance</div>
                                    {
                                        selectedPayment === 'USDT' ? <div className={styles.text}
                                                                          style={{textAlign: 'right'}}>{usdtBalance} {selectedPayment}</div> :
                                            <div className={styles.text}
                                                 style={{textAlign: 'right'}}>{usdcBalance} {selectedPayment}</div>
                                    }
                                </div>
                            </div>
                        )}

                        <div className={styles.priceDisplayOuter}>
                            <div className={styles.priceDisplay}>

                                {selectedPayment==="USD" ?<span className={styles.priceAmount}>${price}</span>: <span className={styles.priceAmount}>{price} {selectedPayment}</span>}
                                <span className={styles.paymentSubtitle}>One time payment</span>
                            </div>
                        </div>
                        {!isMobile && (<div className={styles.buttonContainer}>
                            <button
                                className={styles.upgradeButton}
                                onClick={handlePaymentClick}
                                disabled={isProcessing}
                                style={{backgroundImage: `url(${goldBg})`}}
                            >
                                {isProcessing
                                    ? 'Processing...'
                                    : (selectedPayment !== 'USD' && !walletAddress ? 'Connect Wallet' :
                                        (userClass === 'Amplifier Member'
                                            ? 'Become an Innovator Member Now'
                                            : 'Become an Amplifier Member Now'))}
                            </button>
                        </div>)}

                    </div>
                </div>
            </div>
        </div>,
        document.getElementById('root')
    );
}

export default UpgradeMembershipModal;